import { leaveService } from "@/services/api/features/leaveService";
import { executeAction } from "@/services/api/helpers";


export default {
  namespaced: true,

  state: {
    loading: {},
    error: {},
  },

  getters: {
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },

  mutations: {
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },
  actions: {
    
    // ------------------ FOR ADMIN ONLY -------------------------------

    async getCoachLeaveByStatus({ commit }, params) {
      return executeAction({ commit, action: "getCoachLeaveByStatus" }, () =>
        leaveService.getCoachLeaveByStatus(params)
      );
    },
    async getCoachLeaveDetail({ commit }, coachLeaveId) {
      return executeAction({ commit, action: "getCoachLeaveDetail" }, () =>
        leaveService.getCoachLeaveDetail(coachLeaveId)
      );
    },
    async getCoachRoleLeaveDetail({ commit }, coachLeaveId) {
      return executeAction({ commit, action: "getCoachRoleLeaveDetail" }, () =>
        leaveService.getCoachRoleLeaveDetail(coachLeaveId)
      );
    },
    async postLeaveRequest({ commit }, payload) {
      return executeAction({ commit, action: "postLeaveRequest" }, () =>
        leaveService.postLeaveRequest(payload)
      );
    },
    async getConflictCourseList({ commit }, params) {
      return executeAction({ commit, action: "getConflictCourseList" }, () =>
        leaveService.getConflictCourseList(params)
      );
    },
    async patchApproveLeaveReq({ commit },coachLeaveId) {
      return executeAction({ commit, action: "patchApproveLeaveReq" }, () =>
        leaveService.patchApproveLeaveReq(coachLeaveId)
      );
    },
    async patchSubClassDetail({ commit }, {coachLeaveCourseId,payload}) {
      return executeAction({ commit, action: "patchSubClassDetail" }, () =>
        leaveService.patchSubClassDetail(coachLeaveCourseId,payload)
      );
    },
    async patchRejectLeaveReq({ commit }, params) {
      return executeAction({ commit, action: "patchRejectLeaveReq" }, () =>
        leaveService.patchRejectLeaveReq(params)
      );
    },

    //  ---------------------- FOR COACH ONLY ------------------------

    async getAvailableCoachList({ commit }) {
      return executeAction({ commit, action: "getAvailableCoachList" }, () =>
        leaveService.getAvailableCoachList(), {}, true
      );
    },     
    async getCoachLeaveList({ commit },params) {
      return executeAction({ commit, action: "getCoachLeaveList" }, () =>
        leaveService.getCoachLeaveList(params), {}, true
      );
    },   
    async getCoachEffectCourse({ commit },params) {
      return executeAction({ commit, action: "getCoachEffectCourse" }, () =>
        leaveService.getCoachEffectCourse(params), {}, true
      );
    }, 
    async createCoachLeaveReq({ commit },payload) {
      return executeAction({ commit, action: "createCoachLeaveReq" }, () =>
        leaveService.createCoachLeaveReq(payload), {}, true
      );
    },   
    async editCoachLeaveReq({ commit },{payload,coachLeaveId}) {
      return executeAction({ commit, action: "editCoachLeaveReq" }, () =>
        leaveService.editCoachLeaveReq(payload,coachLeaveId), {}, true
      );
    },
    async cancelCoachLeave({ commit },coachLeaveid) {
      return executeAction({ commit, action: "cancelCoachLeave" }, () =>
        leaveService.cancelCoachLeave(coachLeaveid), {}, true
      );
    },
  },
};
